<template>
  <div id="project_view" v-if="item">
    <div class="centered">
        <div class="yazam_card">
            <div class="info">
                <div class="titles">
                    <div class="first_titles">
                        <p>להלן פרטי המכרז המלאים שמנהל עבורכם <strong>{{  item.user_name }}</strong> במערכת של המכרז השקוף.
לשאלות ופרטים נוספים בנוגע לסעיפים השונים, ניתן לפנות לעו"ד</p>
                        <!-- <div class="title" v-text="item.user_name"></div> -->
                        <!-- <div v-text="item.user_data.company_name"></div>
                        <div v-text="item.user_data.link_company_site"></div> -->
                    </div>
                    <!-- <div class="num_projects">
                        <div class="icon_wrap">
                            <div class="icon building_white_icon"></div>
                        </div>
                        <div> השתתף ב {{item.user_projects.length + item.user_projects_urban.length}} מכרזים</div>
                    </div> -->
                </div>
                <div class="contact">
                    <!-- <div class="detail">
                        <div class="icon_wrap">
                            <div class="icon location_icon"></div>
                        </div>
                        <div v-text="item.user_data.company_address"></div>
                    </div> -->
                    <div class="detail">
                        <div class="icon_wrap">
                            <div class="icon phone_icon"></div>
                        </div>
                        <div v-text="item.user_phone_company_contact" ></div>
                    </div>
                    <!-- <div class="detail">
                        <div class="icon_wrap">
                            <div class="icon contact_icon"></div>
                        </div>
                        <div v-text="item.user_data.phone_company_contact + ' | ' + item.user_data.phone_company_contact"></div>
                    </div> -->
                    <div class="detail">
                        <div class="icon_wrap">
                            <div class="icon email_icon"></div>
                        </div>
                        <div v-text="item.user_username"></div>
                    </div>
                </div>
            </div>
            <div class="yazam_img" :style="bg(item.user_pic_parsed)"></div>
        </div>

        <div class="status_section">
            <h2>סטטוס המכרז</h2>
            <div class="status_bar_container">
                <ul class="status_bar">
                    <li :class="{selected: +item.status_number === 1}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">בהכנה</span>
                    </li>
                    <li :class="{selected: +item.status_number === 2}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">קבלת הצעות</span>
                    </li>
                    <li :class="{selected: +item.status_number === 3}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">נסגר</span>
                    </li>
                    <li :class="{selected: +item.status_number === 4}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">שקלול הצעות</span>
                    </li>
                    <li :class="{selected: +item.status_number === 5}">
                        <div class="icon_container"><div class="icon"></div></div>
                        <span class="text">הסתיים</span>
                    </li>
                </ul>
            </div>
        </div>

        <div class="project_con">
            <existingDetails state="watch" :item="item" v-if="(currentStep === 1 || currentStep === 0)" />
            <ComparisonTable 
                v-if="showComparisonTable && entrepreneurs" 
                :selectedEnts="entrepreneurs"
                :showTrans="showTrans"
            />
            <ClauseComparison 
                v-if="contract"
                ref="clauseComparison"
                :selectedEnts="entrepreneurs"
                :contract="contract"
                :mode="'watch'"
            />
            
        </div>
    </div>
  </div>
</template>

<script>
import existingDetails from '../components/applyingPrj/existingDetails'
import ComparisonTable from '../components/offersDetails/ComparisonTable.vue'
import ClauseComparison from '../components/offersDetails/ClauseComparison.vue'

export default {
    components: {existingDetails, ComparisonTable, ClauseComparison },
    data() {
        return {
            item: null,
            currentStep: 1,
            token: this.$route.params?.token,
            showComparisonTable: true,
            entrepreneurs: [],
            contract: [],
            selectedEntrepreneursIds: [],
            showTrans: true,
            previousStep: 1
        }
    },
    computed: {
        selectedEnts() {
            const selectedItems = this.entrepreneurs.filter(item => this.selectedEntrepreneursIds.includes(item.id));
            return selectedItems.length > 0 ? selectedItems : null;
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
                        this.$bus.$emit('show-loader');

            try {
                const [{ data: project }, { data: { contract, users } }] = await Promise.all([
                    this.api({ action: 'project_get', data: { token: this.token }}),
                    this.api({ action: 'get_applying_project_users', data: { token: this.token }})
                ]);

                this.item = project;
                this.contract = contract;
                this.entrepreneurs = users;
                this.$bus.$emit('hide-loader');

            } catch (error) {
                console.error('Error initializing project:', error);
            }
        },
        toggleComparisonTable() {
            if (!this.showComparisonTable) {
                this.previousStep = this.currentStep;
                this.showComparisonTable = true;
                
                this.showTrans = false;
                setTimeout(() => {
                    this.showTrans = true;
                }, 100);
            } else {
                this.currentStep = this.previousStep;
                this.showComparisonTable = false;
            }
        },
        handleTableScroll(scrollLeft) {
            // Handle scroll event from ComparisonTable component
            if (this.$refs.clauseComparison) {
                this.$refs.clauseComparison.handleTableScroll(scrollLeft);
            }
        },
        bg(pic) {
            return pic ? `background-image: url(${pic})` : '';
        }
    }
}
</script>

<style lang="scss">
#project_view { padding-bottom: 100px;
    .centered {display: flex; flex-direction: column; gap: var(--gap_xbig);}
    .yazam_card {
     min-height: 200px;
    .info { justify-content: space-between;}
    }
    .status_section { display: flex; flex-direction: column; gap: var(--gap_small);
        h2 {}
        .status_bar_container { background: var(--Surface-card-secondary, #F5F9FA); padding: 40px 0px; background: var(--gray); border-radius: var(--radius); }
    }
    .project_con { display: flex; flex-direction: column; gap: var(--gap_mid);
        .title_filters {display: flex; flex-direction: column; gap: var(--gap);
            h2 {}
            .actions { display: flex; justify-content: space-between; gap: var(--gap);
                .btn { background: var(--gray); padding: 10px 20px; border-radius: var(--radius); cursor: pointer; 
                    &.active { 
                        background: var(--dark_blue); 
                        color: white; 
                    }
                }
            }
        }
    }
}
@media (max-width: 768px) {
    
    #project_view {
        overflow-x: hidden;

        .yazam_card {
            flex-direction: column;
            margin: 0 20px;
            padding-bottom: 170px;
            align-items: center;
            padding-left: 25px;
            justify-content: center;
            
            .info { 
                display: flex;
                flex-direction: column;
                align-items: center; 
                justify-content: center;
                text-align: right;
                margin-top: 30px;
                gap:20px;
            }
            .yazam_img { 
               border-radius: 100%;
               background-position: center;
               background-repeat: no-repeat;
               aspect-ratio: 1;
                background-color: white;
                flex-basis: 30%;
                position: absolute;
                width: 200px;
                height: 200px;
                left: 50%;
                transform: translateX(-50%);
                border: 1px solid var(--pageBG);
                background-size: 70%;
                bottom: -70px;    
            }
            .contact {
                &{
                    display: flex;
                    flex-direction: column;
                    gap: var(--gap);
                    flex: 1; 
                    overflow: hidden;
                    align-items: flex-start;
                    align-self: flex-start;

                .icon_wrap{
                    background-color: #CCDAE2;
                    border-radius: 50%;
                    padding:5px;
                }
                }
                .detail{display: flex;
                    gap:var(--gap);
                }
      }
        }
        .status_section { 
            display: flex; 
            flex-direction: column; 
            gap: var(--gap_small);
            padding:0 20px;
            margin-top:20px ;
        h2 {}
        .status_bar_container { 
            background: var(--Surface-card-secondary, #F5F9FA); 
            padding: 40px 0px; 
            background: var(--gray); 
            border-radius: var(--radius); 
            font-size: 15px;

            --circle_size: 24px;
            --loacl_color: #CCDAE2;
            li { position: relative; 
                 flex: 1; 
                 display: flex;
                  flex-direction: column; 
                  align-items: center; 
                  gap: 16px;
                &::before{ content: ''; display: block; position: absolute; top: calc(var(--circle_size) / 2); transform: translateY(-50%); right: 0; left: 50%; height: 2px; background: var(--text_s); }
                &::after{ content: ''; display: block; position: absolute; top: calc(var(--circle_size) / 2); transform: translateY(-50%); right: 50%; left: 0; height: 2px; background: var(--text_s); }

                &:first-child {
                    &::before {display: none;}
                }

                &:last-child {
                    &::after {display: none;}
                }

            & {
            .icon_container { z-index: 1; width: var(--circle_size); height: var(--circle_size); border-radius: 50%;  background: #316A8A;
                .icon {background-position: center center; background-size: contain; background-repeat: no-repeat;background-image: url(../assets/check_white.svg); width: 100%; height: 100%;}
            }
            span { color: var(--dark_blue); font-weight: 500; font-size: 15px;}
        }

        &.selected {
            &::after {background: var(--loacl_color);}
            .icon_container { position: relative; width: var(--circle_size); height: var(--circle_size); display: flex; justify-content: center; align-items: center;background: var(--dark_blue); 
                &::after {content: ''; position: absolute; inset: -3px; background: rgba(57, 195, 169, 0.25); border-radius: 100%;}
                .icon {background: #fff; border-radius: 50%; width: 8px; height: 8px;    z-index: 1;}
            }
            @include mobile {
                span {
                font-size: 15px;
                text-align: center;
                font-weight: 700;
                }
            }
        }
        
        &.selected ~ li { 
            &::after, &::before {background: var(--loacl_color);}
            .icon_container { width: var(--circle_size); height: var(--circle_size); display: flex; justify-content: center; align-items: center; border: 2px solid var(--loacl_color);background: #fff; 
                .icon { background: var(--loacl_color); border-radius: 50%; width: 8px; height: 8px;}
            }
            span { color: var(--text_s);
                @include mobile {
                font-size: 15px;
                text-align: center;
                }
            }
        }
      
         }
        }
    }
    .project_con{
        margin:0 20px;
    }
    
   
    }
#existing_details_apply .part_2{
    padding: 0 !important;
    .head {
    border-bottom: 1px solid var(--light_blue);
    padding-inline: 20px;
    ul.nav_tabs{
       justify-content: flex-start !important;
       flex-wrap: wrap;
    }
}
  .content {
    width:100%;
      padding:10px 5px ;
      #main_building {
        width:100%;
        justify-self: center;
        padding:15px 15px;

        .building_details ,.data_fields_container{
            display: flex;
            flex-direction: column;
            width:100%;
            gap:var(--gap_mid);
        }

        .data_fields_container > .data_1{
            align-items: flex-start;
            li:nth-child(1) {
             width:80%;
            }
        }
        .data_fields_container > .data_2{
            width:100%;
            align-items: flex-start;
            
            .data_container:nth-child(3) {
                order: 2;
            }
            .data_container:nth-child(1) {
                order: 1;
            }
            .data_container:nth-child(2) {
                order: 3;
            }
           
        }
        .data_fields_container > .data_3{
            align-items: flex-start;

            .data_container{
                width: 45% !important;
            }
           
        }
      a.doc_link{
                width: 100% !important;
                text-align: left;
                margin: 0 !important;
            }

            

}
  :deep(.floors_container){
    .head{
        gap: 5px !important;
}
         .fields_container{
        min-width: 100% !important;

        li{
            flex: row !important;
        }
    }
    
   
}

} 


} 





    
}
</style>